export default __webpack_public_path__ + "static/media/questionMark.0fe08936.svg";